import React from 'react';
import PropTypes from 'prop-types';
import LightboxContainerDesktop from './lightbox-container-desktop/LightboxContainerDesktop';
import LightboxContainerMobile from './lightbox-container-mobile/LightboxContainerMobile';
import './Lightbox.css';

import MediaQuery from 'react-responsive';

function getImage(activeImage, galleryImages, isNext) {
  const imageNumber = isNext ? activeImage + 1 : activeImage - 1;

  if (galleryImages[imageNumber]) {
    const showImage = galleryImages[imageNumber].thumbnailUrl;
    return {
      showImage,
      activeImage: imageNumber,
    };
  }

  return false;
}

function hasClass(e, className) {
  return e.target.classList.contains(className);
}

class Lightbox extends React.Component {
  constructor(props) {
    super(props);

    const { galleryImages, imageIndex } = props;
    const showImage = galleryImages[imageIndex].thumbnailUrl;

    this.state = {
      opened: true,
      activeImage: imageIndex,
      showImage,
    };
  }

  setImage = (isNext = true) => {
    const { galleryImages } = this.props;
    const { activeImage } = this.state;

    return this.setState(() => (getImage(activeImage, galleryImages, isNext)));
  }

  closeLightBox = (e) => {
    if (hasClass(e, 'lightbox-overLay') || hasClass(e, 'close')) {
      this.props.setLightBox();
      this.setState(prevState => ({
        opened: !prevState.opened,
      }));
    }
  }

  render() {
    const {
      lang,
      galleryImages,
      handlerDropdown,
      selectedBackground
    } = this.props;

    const {
      opened,
      showImage,
      activeImage,
    } = this.state;

    return (opened &&
      <div
        className="lightbox-overLay"
        onClick={e => this.closeLightBox(e)}
        onKeyDown={() => {}}
        role="presentation"
      >
        
        <MediaQuery maxWidth={991} orientation='portrait'>
        <LightboxContainerMobile
            lang={lang}
            closeLightBox={this.closeLightBox}
            showImage={showImage}
            handleBackgroundOpen={handlerDropdown}
            selectedBackground={selectedBackground}
          />
        </MediaQuery>
        <MediaQuery maxWidth={991} orientation='landscape'>
          <LightboxContainerDesktop
            lang={lang}
            closeLightBox={this.closeLightBox}
            setImage={this.setImage}
            galleryImages={galleryImages}
            showImage={showImage}
            activeImage={activeImage}
          />
        </MediaQuery>
        <MediaQuery minWidth={992}>
          <LightboxContainerDesktop
            lang={lang}
            closeLightBox={this.closeLightBox}
            setImage={this.setImage}
            galleryImages={galleryImages}
            showImage={showImage}
            activeImage={activeImage}
          />
        </MediaQuery>
      </div>
    );
  }
}

Lightbox.defaultProps = {
  setLightBox: () => {},
  lang: {},
  galleryImages: [],
  imageIndex: 0,
  handlerDropdown: () => {},
  selectedBackground: {},
};

Lightbox.propTypes = {
  setLightBox: PropTypes.func,
  lang: PropTypes.object,
  galleryImages: PropTypes.array,
  imageIndex: PropTypes.number,
  handlerDropdown: PropTypes.func,
  selectedBackground: PropTypes.object,
};


export default (Lightbox);



// WEBPACK FOOTER //
// ./src/components/lightbox/Lightbox.jsx